import ApplicationSerializer from 'lumen/serializers/application';

export default class CurrencySerializer extends ApplicationSerializer {
  primaryKey = 'code';
}
